import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationStatus = ({ status, message, email }) => {
  const statusConfig = {
    idle: {
      icon: 'Mail',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted',
      title: 'کد تأیید ارسال شد'
    },
    verifying: {
      icon: 'Loader2',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      title: 'در حال تأیید...',
      animate: true
    },
    success: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      title: 'تأیید موفق'
    },
    error: {
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      title: 'خطا در تأیید'
    },
    expired: {
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      title: 'کد منقضی شده'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.idle;

  return (
    <div className="text-center space-y-3">
      <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full ${config?.bgColor} mb-2`}>
        <Icon 
          name={config?.icon} 
          size={32} 
          className={`${config?.color} ${config?.animate ? 'animate-spin' : ''}`} 
        />
      </div>
      <div className="space-y-1">
        <h3 className={`text-lg font-semibold ${config?.color}`}>
          {config?.title}
        </h3>
        
        {status === 'idle' && email && (
          <p className="text-sm text-muted-foreground">
            کد ۶ رقمی به آدرس {email} ارسال شد
          </p>
        )}
        
        {message && (
          <p className={`text-sm ${config?.color}`}>
            {message}
          </p>
        )}
        
        {status === 'success' && (
          <p className="text-sm text-muted-foreground">
            حساب کاربری شما با موفقیت تأیید شد
          </p>
        )}
      </div>
    </div>
  );
};

export default VerificationStatus;